import { a as __rest, _ as __assign } from './_tslib-ff3a08af.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { withStyles, withTheme, Button as Button$1, makeStyles, CircularProgress } from '@material-ui/core';
import { s as styleConstants } from './constants-3b80be2a.js';

var StyledButton = withStyles(function (theme) {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 36,
            minWidth: 60,
            borderRadius: 5,
            fontSize: 13,
            fontWeight: 600,
            textTransform: 'none',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            padding: theme.spacing(1, 4),
            outline: 'none'
        },
        contained: {
            borderWidth: 3,
            outline: 'none',
            color: 'white'
        },
        outlined: {
            backgroundColor: 'white',
            borderWidth: 3,
            '&:hover': {
                backgroundColor: 'white',
                borderWidth: 3
            },
            outline: 'none'
        },
        text: {
            padding: 0,
            border: 'transparent',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none',
                border: 'transparent'
            },
            outline: 'none'
        },
        disabled: {
            backgroundColor: styleConstants.colors.grey2,
            color: styleConstants.colors.grey,
            outline: 0
        }
    };
})(withTheme(Button$1));
var useStyles = makeStyles(function (theme) {
    return {
        spinner: function (_a) {
            var color = _a.color;
            return {
                marginLeft: theme.spacing(1),
                color: color
            };
        }
    };
});
var Button = function (_a) {
    var loading = _a.loading,
        children = _a.children,
        _b = _a.variant,
        variant = _b === void 0 ? 'contained' : _b,
        props = __rest(_a, ["loading", "children", "variant"]);
    var classes = useStyles({
        color: loading && !props.disabled && variant === 'contained' ? 'white' : 'primary'
    });
    var btnProps = __assign(__assign({}, props), { color: props.color || 'primary', variant: variant });
    return jsxs(StyledButton, __assign({ classes: { root: "".concat(props.className) } }, btnProps, { children: [children, " ", loading && jsx(CircularProgress, { className: "".concat(classes.spinner, " ml-2"), size: 16 })] }));
};

export { Button as B, StyledButton as S };
